<script lang="typescript">
  import Panel from "../../common/Panel.svelte";

  import { createAddEvent, service } from '../addmachine';
  import type { Context } from '../addmachine';
  import { selectedDay } from '../store';

  $: send = $service.send;
  let context:Context;
  $: context = $service.context;
  $: state = $service.machine.current;
  $: types = context.types;
  $: values = context.values;
  $: error = context.error;
  $: saving = state === "saving";
  $: disabled = saving;
  $: save = () => send(createAddEvent($selectedDay));
  $: cancel = () => send("cancel");
  $: showDuration = values.type ? values.type.duration_in_minutes == 0 : false;
  $: forSale = values.type ? values.type.for_sale : false;
  $: price = values.type ? values.type.price : 0;

  const typeChanged = () => send("type_changed");
</script>

<div>
  <!--
  <pre>
  {JSON.stringify(context, null, 2)}
  </pre>
  -->
  <h3>Uusi tapaaminen</h3>
  <form on:submit|preventDefault={save} class="general">
    <p>
      <label for="type">Tapaamisen tyyppi</label>
      <select
        bind:value={values.type}
        on:change={typeChanged}
        name="type"
        id="type"
        {disabled}
        required
      >
        {#each types as meetingType}
          <option value={meetingType}>{meetingType.name}</option>
        {/each}
      </select>
    </p>
    <p>
      <label for="title">Otsikko</label>
      <input
        bind:value={values.title}
        name="title"
        id="title"
        {disabled}
      />
    </p>
    <p>
      <label for="description">Kuvaus</label>
      <textarea
          rows=5
          bind:value={values.description}
          name="description"
          id="description"
          {disabled}
          ></textarea>
    </p>
    <p>
      <label for="time">Kellonaika</label>
      <input
        bind:value={values.time}
        required
        min="07:00"
        max="22:00"
        type="time"
        name="time"
        id="time"
        {disabled}
      />
    </p>
    {#if showDuration}
      <p>
      <label for="duration_in_minutes">Kesto minuuteissa</label>
      <input
          bind:value={values.duration_in_minutes}
          required={showDuration}
          type="number"
          name="duration_in_minutes"
          id="duration_in_minutes"
          min="30"
          max="240"
          {disabled}
          />
      </p>
    {/if}
    {#if forSale}
    <p>
      Tapaaminen lisätään myyntiin hinnalla {price} euroa.
    </p>
    {:else}
    <p>
      Tapaamista ei lisätä myyntiin. Kopioi salasana tapaamisen lisäämisen jälkeen ja lähetä se tapaamisen osallistujille.
    </p>
    {/if}
    {#if saving}
      <p>
      <i class="fas fa-spinner fa-spin fa-lg" />
      Tallennetaan uusi tapaaminen
      </p>
    {/if}
    {#if error}
      <Panel type="error">
        <p>
        Virhe uuden tapaamisen tallentamisessa. Yritä hetken kuluttua uudelleen.
        </p>
        {@html error}
      </Panel>
    {/if}
    <p>
    <input
        type="submit"
        id="new-meeting"
        name="new-meeting"
        value="Lisää videotapaaminen"
        {disabled}
        />
    </p>
    <p>
    <button on:click={cancel} {disabled}>Peru lisääminen</button>
    </p>
  </form>
</div>

<style>
  label {
    display: block;
  }

  input#title {
    width: 600px;
  }

  textarea {
    width: 600px;
  }
</style>
